import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export const FooterItem = ({ isRawLink, title, url, target }) => {
  return (
    <div className="group flex cursor-pointer">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        className="h-5 w-5 stroke-white group-hover:stroke-[--color-hover]"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m8.25 4.5 7.5 7.5-7.5 7.5"
        />
      </svg>

      {isRawLink ? (
        <a
          href={url}
          target={target}
          className="ml-[4px] max-w-[303px] text-[14px] font-normal leading-[22px] text-[--color-footer] group-hover:text-[--color-hover]"
        >
          {title}
        </a>
      ) : (
        <Link
          to={url}
          target={target}
          className="ml-[4px] max-w-[303px] text-[14px] font-normal leading-[22px] text-[--color-footer] group-hover:text-[--color-hover] "
        >
          {title}
        </Link>
      )}
    </div>
  );
};
FooterItem.propTypes = {
  title: PropTypes.string,
};
